// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1341":"dbe810ee","1467":"3105dd53","2196":"181732f6","4325":"181732f6","8090":"181732f6"}[chunkId] + ".chunk.css";
};